<script>
    import R, {LOADER} from "../lib/requests";
    import {SERVICE_CUSTOM_FIELD, SERVICE_TYPE} from "../lib/constants";
    import {slide} from 'svelte/transition';
    import {setFocusTo, formatDate} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import PriceControl from "../components/controls/PriceControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import TagsControl from "../components/controls/TagsControl.svelte";
    import AssignedUsers from "../components/controls/AssignedUsers.svelte";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";


    export let serviceId = null;
    export let wsServiceId = null;
    export let clientId = 0;
    export let projectId = 0;
    export let closeCallback;

    let service = null;
    let client = null;
    let wsService = null;
    let modalTitle = 'Υπηρεσία';
    let displayGrid = false;

    const initialize = () => {
        load();
    }

    const load = () => {

        const onSuccess = result => {
            if (serviceId > 0) {
                service = result.service;
                service.is_private = service.visible_by > 0;
                service.enable_notifications = ~~service.enable_notifications;
                client = result.client;
                wsService = service.ws_service;
                wsService.notifications = result.notifications;
            } else {
                wsService = result;
                service = {
                    id: 0,
                    name: '',
                    duration: wsService.duration,
                    price: null,
                    notification_email: null,
                    enable_notifications: 0,
                    notes: null,
                    is_active: 1,
                    ws_service_id: wsService.id,
                    is_private: false,
                    client_id: clientId,
                    project_id: projectId,
                    fields: [],
                    users: []
                };

                // set new service fields
                wsService.fields.map(item => {
                    service.fields.push({
                        id: item.id,
                        field_type_id: item.field_type_id,
                        name: item.name,
                        value: null
                    });
                });
            }

            modalTitle = wsService.name;

            if (wsService.type == SERVICE_TYPE.SUBSCRIPTION && !service.subscription) {
                service.subscription = {
                    id: 0,
                    price: service.price,
                    start_at: formatDate(new Date, 'y-m-d'),
                    end_at: null,
                }
                setDurationDate();
            }

            displayGrid = wsService.type == SERVICE_TYPE.SUBSCRIPTION || service.fields.length > 0;

            setFocusTo('serviceName');
        };

        const onFailure = err => {
        };

        let action;
        let data;
        if (!serviceId) {
            action = 'new';
            data = {ws_service_id: wsServiceId};
        } else {
            action = 'details';
            data = serviceId;
        }
        R.handle(R.service[action], data, onSuccess, onFailure, LOADER.POPUP);
    };

    const save = () => {
        const onSuccess = result => {
            close(result);
        }

        const onFailure = err => {
            if (err.code && err.code === 'already_exist') {
                Alert.warning("Υπηρεσία", "Υπάρχει ήδη καταχωρημένη υπηρεσία με αυτό το όνομα!");
                return;
            }

            Alert.warning("Υπηρεσία", "Παρουσιάστηκε σφάλμα κατά την καταχώρηση της υπηρεσίας!");
        };

        service.name = service.name.trim();

        if (!service.name) {
            Notifier.showError("Δεν έχει οριστεί το όνομα της υπηρεσίας!");
            setFocusTo('serviceName');
            return;
        }

        if (service.enable_notifications && !service.notification_email) {
            Notifier.showError("Δεν έχει οριστεί το email ειδοποιήσεων!");
            setFocusTo('notificationEmail');
            return;
        }

        if (wsService.type == SERVICE_TYPE.SUBSCRIPTION) {
            service.subscription.price = service.price;
        } else {
            delete (service.subscription);
        }

        let action = serviceId == 0 ? 'create' : 'edit';
        R.handle(R.service[action], service, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        service = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const onDurationChange = () => {
        setDurationDate();
    }

    const onNotificationsChange = ({detail}) => {
        if (detail.checked && !service.notification_email) {
            service.notification_email = client.email;
        }
    }

    const setDurationDate = () => {
        if (wsService && service.subscription.start_at) {
            let start = new Date(service.subscription.start_at);
            service.subscription.end_at = formatDate(start.addMonths(parseInt(service.duration)), 'y-m-d');
        }
    }

    initialize();
</script>


{#if service}
    <Modal modalMd={ displayGrid } title="{ modalTitle }" icon="service" closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class:col-lg-6={ displayGrid }>
                    <div class="form-group">
                        <label>Όνομα</label>
                        <input type="text" class="form-control" id="serviceName" bind:value="{ service.name }"
                               required>
                    </div>
                    <div class="form-group">
                        <label>Πελάτης</label>
                        <ClientControl bind:clientId={ service.client_id } {client}/>
                    </div>
                    <div class="row">
                        <div class="col-6 form-group" class:hidden={  wsService.type == SERVICE_TYPE.NORMAL }>
                            <label>Διάρκεια (μήνες)</label>
                            <input type="number" class="form-control" bind:value="{ service.duration }"
                                   on:change="{ onDurationChange }" required>
                        </div>
                        <div class="col-6 form-group">
                            <label>Τιμή</label>
                            <PriceControl bind:value="{ service.price }"/>
                        </div>
                    </div>
                    {#if wsService.type == SERVICE_TYPE.SUBSCRIPTION}
                        <div in:slide="{{ duration: 100 }}" out:slide="{{ duration: 100 }}">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Έναρξη</label>
                                        <input type="date" class="form-control"
                                               bind:value="{ service.subscription.start_at }"
                                               required on:change={ setDurationDate }>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Λήξη</label>
                                        <input type="date" class="form-control"
                                               bind:value="{ service.subscription.end_at }"
                                               required>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}
                    <div class="form-group">
                        {#if wsService.type == SERVICE_TYPE.SUBSCRIPTION}
                                <textarea class="form-control" bind:value="{ service.subscription.notes }"
                                          placeholder="σημειώσεις"></textarea>
                        {:else}
                                <textarea class="form-control" bind:value="{ service.notes }"
                                          placeholder="σημειώσεις"></textarea>
                        {/if}
                    </div>
                    <div class="form-group">
                        <Checkbox label="Ενεργή υπηρεσία" bind:checked={ service.is_active }/>
                    </div>
                </div>
                <div class:col-lg-6={ displayGrid }>
                    <table class="table table-fields">
                        <tbody>
                        {#each service.fields as field}
                            <tr>
                                <td class="field-label">{ field.name }</td>
                                <td>
                                    {#if field.field_type_id == SERVICE_CUSTOM_FIELD.TEXT}
                                        <input type="text" class="form-control" bind:value="{ field.value }">
                                    {:else if field.field_type_id == SERVICE_CUSTOM_FIELD.NUMBER}
                                        <input type="number" class="form-control" bind:value="{ field.value }">
                                    {:else}
                                        <input type="date" class="form-control" bind:value="{ field.value }">
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>

                    <!--{#if notifications != null}-->
                    <!--    {#if notifications.length}-->
                    <!--        EIDOPOIHSEIS-->
                    <!--        {#each notifications as item}-->
                    <!--            <Checkbox label="{ SUBSCRIPTION_NOTIFICATIONS[item.type] }"-->
                    <!--                      bind:checked={ item.is_selected }/>-->
                    <!--        {/each}-->
                    <!--    {/if}-->
                    <!--{/if}-->
                    {#if wsService.type == SERVICE_TYPE.SUBSCRIPTION}
                        <div class="form-group">
                            <Checkbox label="Να στέλνονται ειδοποιήσεις λήξης και ανανέωσης συνδρομής"
                                      bind:checked={ service.enable_notifications }
                                      on:change={ onNotificationsChange }/>
                        </div>
                        {#if !wsService.notifications.length}
                            <div class="alert alert-warning p-2">
                                Δεν έχουν οριστεί ειδοποιήσεις για αυτό το είδος υπηρεσίας.
                            </div>
                        {/if}
                        <div class="form-group">
                            <label>Email ειδοποιήσεων</label>
                            <input type="email" class="form-control" id="notificationEmail"
                                   bind:value="{ service.notification_email }">
                        </div>
                    {/if}
                    <!--{#each service.fields as field}-->
                    <!--    <div class="form-group">-->
                    <!--        <label>{ field.name }</label>-->
                    <!--        <input type="text" class="form-control" bind:value="{ field.value }">-->
                    <!--    </div>-->
                    <!--{/each}-->

                    <div class="form-group">
                                <label class="fw-semibold">Χρήστες</label>
                                <AssignedUsers bind:users={service.users}/>
                            </div>
                </div>
            </div>
            <TagsControl bind:tags={service.tags} service/>

            <hr class="full-hr">
            <div class="text-end">
                <button class="btn btn-primary me-2" on:click={ save }>Ενημέρωση</button>
                <div class="btn btn-link" on:click="{ () => close() }">Κλείσιμο</div>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .table-fields {
        border-bottom: 1px solid #e4eaee;
    }

    .table-fields td {
        border-bottom: none;
    }

    .table-fields .field-label {
        vertical-align: middle;
    }
</style>